import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";

import { Spinner, Button } from "react-bootstrap";

const VPPersonalViewCC = ({ fileUrl, fileName }) => {
  const [isPdf, setIsPdf] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check file type
  const checkFileType = () => {
    const extension = fileUrl?.split(".").pop();
    if (extension === "pdf") {
      setIsPdf(true);
    }
    setLoading(false);
  };

  // Call check on initial render
  useEffect(() => {
    checkFileType();
  }, [fileUrl]);

  return (
    <div className="position-relative vpvcc-file-viewer-container">
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {isPdf ? (
            <div className="vpvcc-pdf-icon">
              {/* Show PDF icon when it's a PDF file */}
              <Icon
                icon="vscode-icons:file-type-pdf2"
                style={{ fontSize: "100px", color: "#FF5722" }}
              />
            </div>
          ) : (
            <div className="vpvcc-image-viewer">
              {/* Show image if it's not a PDF */}
              <img src={fileUrl} alt={fileName} className="img-fluid" />
            </div>
          )}
          <div className="vpvcc-file-overlay"></div>

          <div className="position-absolute vpvcc-file-details d-flex justify-content-between align-items-center mt-2">
            <div className="vpvcc-file-name">{fileName}</div>
            <Button
              className="vpvcc-file-open-button"
              href={fileUrl}
              target="_blank"
              variant="warning"
            >
              Open file
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default VPPersonalViewCC;
